import { render, staticRenderFns } from "./FlexEditor.vue?vue&type=template&id=203bd8e0&"
import script from "./FlexEditor.vue?vue&type=script&lang=ts&"
export * from "./FlexEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports